import { SearchCompositionDto } from './dtos/search-composition.dto';
import { axiosCore } from './http-core-service';
import { ResultSearchDto } from './dtos/result-search.dto';
import { CompositionsDto } from './dtos/compositions.dto';
import { SearchLocalAuthorityDto } from './dtos/search-local-authority.dto';
import { LocalAuthorityDto } from './dtos/local-authority.dto';
import {
    SearchTerritoryEstablishmentCompositionDto,
    TerritoryEstablishmentCompositionDto,
} from './dtos/territory-establishment-composition.dto';

const territoryEstablishmentsRequests = new Map<
    string,
    Promise<ResultSearchDto<TerritoryEstablishmentCompositionDto>>
>();

/**
 * Méthode qui récupère les compositions pour un mandat et utilisateur
 * @return des compositions
 */
export const searchCompositions = async (data: SearchCompositionDto): Promise<ResultSearchDto<CompositionsDto>> => {
    let criterions = '';
    const sortFields: Partial<Record<keyof CompositionsDto, string>> = {
        name: 'nom',
        title: 'titreMandatDesignation',
        localAuthority: 'etablissementNom',
    };
    //si recherche par nom
    if (data.paramName) {
        criterions += `&name=${data.paramName}`;
    }
    //si recherche par collectivité
    if (data.paramLocalAuthority) {
        criterions += `&localAuthority=${data.paramLocalAuthority}`;
    }
    //si recherche par titre
    if (data.paramTitle) {
        criterions += `&title=${data.paramTitle}`;
    }
    // tri
    if (data.sort && data.order && sortFields[data.sort]) {
        criterions += `&order=${sortFields[data.sort]}&sort=${data.order.toUpperCase()}`;
    }
    //si on est dans le cas d'un établissement
    if (data.etablissementId) {
        criterions += `&etablissementId=${data.etablissementId}`;
    }
    // groupe élu
    if (data.groupId !== undefined && data.groupId !== null && data.groupId !== '' && data.groupId !== '0') {
        criterions += `&groupId=${data.groupId}`;
    }
    if (data.groupType) {
        criterions += `&groupType=${data.groupType}`;
    }
    // territoire
    if (data.territoryId) {
        criterions += `&territoryId=${data.territoryId}`;
    }
    // Création d'un json pour la requête
    const response = await axiosCore.get(
        `/api/compositions/mandates/${data.mandateId}/search?page=${data.page + 1}&itemsPerPage=${
            data.itemsPerPage
        }${criterions}`
    );
    return response.data;
};
/**
 * Méthode qui récupère les Collectivités rattachées
 * @return des Collectivités rattachées
 */
export const searchLocalAuthorities = async (
    data: SearchLocalAuthorityDto
): Promise<ResultSearchDto<LocalAuthorityDto>> => {
    let criterions = '';
    //si recherche par Compétence
    if (data.authority) {
        criterions += `&authority=${data.authority}`;
    }
    //si recherche par etablissement
    if (data.establishment) {
        criterions += `&establishment=${data.establishment}`;
    }
    //si recherche par Désignation
    if (data.naming) {
        criterions += `&naming=${data.naming}`;
    }
    //si recherche par Date d’adhésion
    if (data.membershipDate) {
        criterions += `&membershipDate=${data.membershipDate}`;
    }
    //tri
    if (data.sort) {
        criterions += `&sort=${data.sort}`;
    }
    //etablissementId
    if (data.etablissementId) {
        criterions += `&etablissementId=${data.etablissementId}`;
    }
    // order
    if (data.order) {
        criterions += `&order=${data.order}`;
    }
    // territoireID
    if (data.territoireId) {
        criterions += `&territoireId=${data.territoireId}`;
    }

    // Création d'un json pour la requête
    const response = await axiosCore.get(
        `/api/compositions/mandates/${data.mandateId}/local-authority/search?page=${data.page}&itemsPerPage=${data.itemsPerPage}${criterions}`
    );
    return response.data;
};

export const searchTerritoryEstablishments = async (
    data: SearchTerritoryEstablishmentCompositionDto
): Promise<ResultSearchDto<TerritoryEstablishmentCompositionDto>> => {
    const params = new URLSearchParams({
        territoryId: data.territoryId,
        page: String(data.page + 1),
        itemsPerPage: String(data.itemsPerPage),
    });

    if (data.designation) {
        params.set('designation', data.designation);
    }
    if (data.president) {
        params.set('president', data.president);
    }
    if (data.vicePresident) {
        params.set('vicePresident', data.vicePresident);
    }
    if (data.sort) {
        params.set('sort', String(data.sort));
    }
    if (data.order) {
        params.set('order', data.order);
    }

    const requestKey = `${data.mandateId}-${params.toString()}`;
    const currentRequest = territoryEstablishmentsRequests.get(requestKey);

    if (currentRequest) {
        return currentRequest;
    }

    const request = axiosCore
        .get(`/api/compositions/mandates/${data.mandateId}/territory-establishments/search?${params.toString()}`)
        .then(response => response.data)
        .finally(() => {
            territoryEstablishmentsRequests.delete(requestKey);
        });

    territoryEstablishmentsRequests.set(requestKey, request);

    return request;
};
